import { useHistory } from "react-router"

// libraries
import { Tab, Tabs } from "@mui/material"

// providers
import { fromInfo, trans } from "@/_providers/Translation"

// components
import Help from "@/components/partials/Help"

export default function MainTabs(props) {
  const history = useHistory()

  const handlePosition = (e, v) => {
    e.preventDefault()

    history.push("/parts/storage/" + v)
  }
  console.log(props.filter.stock)
  return (
    <>
      <Tabs value={props.filter.stock}>
        <Tab
          label={trans('labels.used')}
          onClick={(e) => handlePosition(e, "")}
          className={props.filter.stock === "" ? "active" : ""}
          value=""
        />
        <Tab
          label={trans("labels.inStorage")}
          onClick={(e) => handlePosition(e, "office")}
          className={props.filter.stock === "office" ? "active" : ""}
          value="office"
        />
        <Tab
          label={trans("labels.inVan")}
          onClick={(e) => handlePosition(e, "van-used")}
          className={props.filter.stock === "van" ? "active" : ""}
          value="van"
        />
      </Tabs>

      {/* <div style={{ position: "relative" }}>
        <button
          className={[
            props.filter.stock === "office" ? "active" : "",
            "green",
          ].join(" ")}
          onClick={(e) => handlePosition(e, "office")}
        >
          {trans("labels.inStorage")}
        </button>
        <Help style={{ position: "absolute", top: "-9px", right: 0 }}>
          {fromInfo("parts.inStockButton")}
        </Help>
      </div>
      <div style={{ position: "relative" }}>
        <button
          className={[
            props.filter.stock === "van" ? "active" : "",
            "yellow",
          ].join(" ")}
          onClick={(e) => handlePosition(e, "van-used")}
        >
          {trans("labels.inVan")}
        </button>
        <Help style={{ position: "absolute", top: "-9px", right: 0 }}>
          {fromInfo("parts.inVanButton")}
        </Help>
      </div> */}
    </>
  )
}
